import Popover, { duration } from "./Popover";

export { duration };

export default Popover;
